<template>
<div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="{ backgroundImage: 'url(' + header + ')' }"
    ></parallax>
    <div class="main main-raised">
        <div class="error-page text-center">
            <md-icon>sentiment_dissatisfied</md-icon>
            <h5>Sorry, the page you are looking for cannot be found...</h5>
            <h5>We have completely redone our website, you may find the product you are looking for <a href="/products">here</a>.</h5>
            <md-button
              href="/"
              class="md-primary md-lg"
              >Return to home</md-button
            >
        </div>
    </div>
</div>
</template>
<script>
export default {
    components: {

    },
    bodyClass: "profile-page",
    props: {
        header: {
            type: String,
            default: require("@/assets/img/city-profile.jpg")
        },
    },
    metaInfo: {
        meta: [   
        { name: 'robots', content: 'noindex,follow'}
        ]
    }
}
</script>
<style lang="scss" scoped>
.error-page{
    min-height: 640px;
    padding: 240px 24px;
}
</style>